export default __webpack_public_path__ + "static/media/ballon.81c34e9d.png";